<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        Do you think there is a way to improve the freshman labs to give more opportunities to do
        science?
        <i>Please specify anything that even MIGHT be helpful to future classes. Open ended.</i>
      </p>

      <s-textarea v-model="inputs.input1" outlined />
    </v-form>
  </div>
</template>

<script>
import STextarea from '@/common/components/STextarea.vue';
import DynamicQuestionMixin from '../../mixins/dynamic-question';

export default {
  name: 'OleMissSurveyQ14',
  components: {
    STextarea,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1: null,
      },
    };
  },
};
</script>
<style scoped></style>
